import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import ServiceTypesTable, { SERVICE_TYPE_COLUMNS, SERVICE_TYPE_CARDS, SERVICE_TYPE_MIN_TABLE_WIDTH } from 'components/Tables/ServiceTypes';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'serviceTypeStore') @observer
class ServiceTypeIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      serviceTypeStore,
      serviceTypeStore: {
        serviceType: {
          isLoading,
          isError
        }
      }, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={SERVICE_TYPE_COLUMNS}
          cards={SERVICE_TYPE_CARDS}
          minTableWidth={SERVICE_TYPE_MIN_TABLE_WIDTH}
          noun="service types"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="service types" onRetry={() => serviceTypeStore.loadServiceTypes()} />;
    }
    if (!isError && !isLoading) {
      content = <ServiceTypesTable />
    }
    return (
      <div>
        <Helmet>
          <title>Service Types | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.ServiceType key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default ServiceTypeIndexPage;
